import { REVIEW_BLOCK_TYPES } from '@Pages/happyFlowPages/reviewPage/types';
import type { FieldValidationError } from '@Store/slices/customer/customer.types';
import {
  FieldValidationFieldName,
  FieldValidationObjectName,
} from '@Store/slices/customer/customer.types';

const FIELD_TO_REVIEW_BLOCK: Record<
  FieldValidationObjectName,
  Partial<Record<FieldValidationFieldName, REVIEW_BLOCK_TYPES>>
> = {
  [FieldValidationObjectName.CONTACT]: {
    [FieldValidationFieldName.EMAIL]: REVIEW_BLOCK_TYPES.CONTACT,
    [FieldValidationFieldName.PHONE_NUMBER]: REVIEW_BLOCK_TYPES.CONTACT,
  },
  [FieldValidationObjectName.PHONE_NUMBER]: {
    [FieldValidationFieldName.PHONE_NUMBER]: REVIEW_BLOCK_TYPES.PHONE,
  },
  [FieldValidationObjectName.IDENTITY]: {
    [FieldValidationFieldName.SSN]: REVIEW_BLOCK_TYPES.IDENTITY,
    [FieldValidationFieldName.BIRTH_DATE]: REVIEW_BLOCK_TYPES.IDENTITY,
  },
  [FieldValidationObjectName.HOME_ADDRESS]: {
    [FieldValidationFieldName.LINE1]: REVIEW_BLOCK_TYPES.HOME_ADDRESS,
    [FieldValidationFieldName.CITY]: REVIEW_BLOCK_TYPES.HOME_ADDRESS,
    [FieldValidationFieldName.STATE]: REVIEW_BLOCK_TYPES.HOME_ADDRESS,
    [FieldValidationFieldName.POSTAL_CODE]: REVIEW_BLOCK_TYPES.HOME_ADDRESS,
  },
  [FieldValidationObjectName.BUSINESS_DETAILS]: {
    [FieldValidationFieldName.BUSINESS_NAME]: REVIEW_BLOCK_TYPES.BUSINESS_DETAILS,
    [FieldValidationFieldName.BUSINESS_TYPE]: REVIEW_BLOCK_TYPES.BUSINESS_DETAILS,
    [FieldValidationFieldName.EIN]: REVIEW_BLOCK_TYPES.BUSINESS_DETAILS,
    [FieldValidationFieldName.NAICS]: REVIEW_BLOCK_TYPES.BUSINESS_DETAILS,
  },
  [FieldValidationObjectName.BUSINESS_ADDRESS]: {
    [FieldValidationFieldName.LINE1]: REVIEW_BLOCK_TYPES.OPERATIONAL_ADDRESS,
    [FieldValidationFieldName.CITY]: REVIEW_BLOCK_TYPES.OPERATIONAL_ADDRESS,
    [FieldValidationFieldName.STATE]: REVIEW_BLOCK_TYPES.OPERATIONAL_ADDRESS,
    [FieldValidationFieldName.POSTAL_CODE]: REVIEW_BLOCK_TYPES.OPERATIONAL_ADDRESS,
  },
};

export const mapFieldValidationErrors = (errors: FieldValidationError[]) => {
  const blockErrors = new Set<REVIEW_BLOCK_TYPES>();

  for (const { objectName, fieldName } of errors) {
    const objectMap = FIELD_TO_REVIEW_BLOCK[objectName];
    if (!objectMap) continue;
    const blockType = objectMap[fieldName];
    if (blockType) {
      blockErrors.add(blockType);
    }
  }

  return blockErrors;
};
